import React, { useEffect, useState } from 'react'
import { Blacked, ModalContent, ModalHeader, ModalInput, ModalSubmit, ModalTitle, ModalWrapper, SetTemplateChoose, SetTemplateSelect, SetTemplateWrapper } from './styles';
import { Icon } from 'CRM/organism/Main/styles';
import { FaChevronLeft } from 'react-icons/fa6';
import { Input, Select, message } from 'antd'
import { ChromePicker } from 'react-color';
import API from 'utils/api';
import { useToken } from 'app/hooks';
import { usePathList } from 'CRM/hooks/GetPathList';
import TextArea from 'antd/es/input/TextArea';
import { useCategoryList } from 'CRM/hooks/GetCategory';
import { usePlatformList } from 'CRM/hooks/GetPlatformList';
import {useIsMobile} from "./IsMobile";

export const SetTemplate = ({ setIsSetTemplate }) => {
  const IsMobile = useIsMobile();
  const { data: token } = useToken();
  const { categoryList, mutate } = useCategoryList();
  const [category, setCategory] = useState(categoryList?.[0]?.id);
  const [template, setTemplate] = useState('');

  const [categoryAdd, setCategoryAdd] = useState('');
  const [templateAdd, setTemplateAdd] = useState('');

  const [categoryEdit, setCategoryEdit] = useState();
  const [categoryEditTxt, setCategoryEditTxt] = useState('');
  const [templateEdit, setTemplateEdit] = useState('');

  const [categoryDelete, setCategoryDelete] = useState(null);

  const [choose, setChoose] = useState('');

  useEffect(() => {
    setTemplate(categoryList?.find(it => it.id == category)?.template)
    setTemplateEdit(categoryList?.find(it => it.id == categoryEdit)?.template)
    setCategoryEditTxt(categoryList?.find(it => it.id == categoryEdit)?.name)
  }, [category, categoryEdit])

  const clickAdd = () => {
    const shouldEdit = window.confirm(`카테고리를 등록하시겠습니까?`);
    if(shouldEdit) {
      if(categoryAdd == '') {
        message.error('카테고리를 입력해주세요.')
      } else if (templateAdd == '') {
        message.error('템플릿을 입력해주세요.')
      } else {
        API.post('/system/board/request/category', token + '', {
          name: categoryAdd,
          template: templateAdd
        })
        .then((res: any) => {
          if (res.result.success) {
            message.success('등록되었습니다');
            mutate();
            setChoose('');
          }
        })
        .catch((err: any) => {})
      }
    }
  }
  const clickEdit = () => {
    const shouldEdit = window.confirm(`카테고리를 수정하시겠습니까?`);
    if(shouldEdit) {
      if(categoryEditTxt == '') {
        message.error('카테고리를 입력해주세요.')
      } else if (templateEdit == '') {
        message.error('템플릿을 입력해주세요.')
      } else {
        API.put('/system/board/request/category/' + categoryEdit, token + '', {
         datas:{
           name: categoryEditTxt,
           template: templateEdit
         }
        })
        .then((res: any) => {
          if (res.result.success) {
            message.success('등록되었습니다');
            mutate();
            setChoose('');
          }
        })
        .catch((err: any) => {})
      }
    }
  }
  const clickDelete = () => {
    const shouldEdit = window.confirm(`카테고리를 삭제하시겠습니까?`);
    if(shouldEdit) {
      if(categoryDelete == null) {
        message.error('카테고리를 선택해주세요.')
      } else {
        API.delete('/system/board/request/category/' + categoryDelete, token + '', {})
        .then((res: any) => {
          if (res.result.success) {
            message.success('삭제되었습니다');
            mutate();
            setChoose('');
          }
        })
        .catch((err: any) => {})
      }
    }
  }

  return (
    <>
      <Blacked onClick={() => setIsSetTemplate(false)} />
      {IsMobile ?
        <ModalWrapper IsMobile={IsMobile}>
          <ModalHeader>
            <Icon onClick={() => setIsSetTemplate(false)}><FaChevronLeft /></Icon>
            <ModalTitle>템플릿 관리</ModalTitle>
            <div></div>
          </ModalHeader>

          <SetTemplateChoose style={{display: 'flex', flexDirection: 'row', width: '100%', marginBottom: 10, marginTop: 30}}>
            <button onClick={() => setChoose('')} style={{backgroundColor: '#d8d8d8', color: '#4d4b4b'}}>
              리스트 보기
            </button>
            <button onClick={() => setChoose('등록')} style={{backgroundColor: '#49cc90'}}>
              등록
            </button>
          </SetTemplateChoose>

          <SetTemplateChoose style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
            <button onClick={() => setChoose('수정')} style={{backgroundColor: '#fca130'}}>
              수정
            </button>
            <button onClick={() => setChoose('삭제')} style={{backgroundColor: '#f93e3e'}}>
              삭제
            </button>
          </SetTemplateChoose>

          <SetTemplateWrapper>
            <SetTemplateSelect>
              {choose == '등록' && (
                <div style={{position: 'relative'}}>
                  <ModalInput style={{padding: 20, textAlign: 'center', paddingBottom: 10}}>
                    <label htmlFor='name' style={{fontSize: 22, fontWeight: 600}}>카테고리 등록</label>
                    <ModalSubmit style={{backgroundColor: '#49cc90', border: 'none'}} onClick={clickAdd}>등록</ModalSubmit>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='name'>카테고리</label>
                    <Input type='text' value={categoryAdd} onChange={(e) => setCategoryAdd(e.target.value)} placeholder='등록하실 카테고리명을 입력해주세요.' />
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='desc'>내용입력</label>
                    <TextArea
                      value={templateAdd}
                      onChange={(e) => setTemplateAdd(e.target.value)}
                      placeholder="등록하실 템플릿을 입력해주세요."
                      style={{ width: '100%', height: 350, resize: 'none', fontFamily: 'Pretendard' }}
                    />
                  </ModalInput>
                </div>
              )}
              {choose == '수정' && (
                <div style={{position: 'relative'}}>
                  <ModalInput style={{padding: 20, textAlign: 'center', paddingBottom: 10}}>
                    <label htmlFor='name' style={{fontSize: 22, fontWeight: 600}}>카테고리 수정</label>
                    <ModalSubmit style={{backgroundColor: '#fca130', border: 'none'}} onClick={clickEdit}>수정</ModalSubmit>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='name'>카테고리</label>
                    <Select value={categoryEdit} onChange={(e) => setCategoryEdit(e)} placeholder='카테고리 선택' style={{fontFamily: 'Pretendard'}}>
                      {categoryList?.map(it => (
                        <option value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
                      ))}
                    </Select>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='name'>카테고리 수정</label>
                    <Input type='text' value={categoryEditTxt} onChange={(e) => setCategoryEditTxt(e.target.value)} />
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='desc'>내용입력</label>
                    <TextArea
                      value={templateEdit}
                      onChange={(e) => setTemplateEdit(e.target.value)}
                      placeholder="카테고리 선택 후 작성"
                      style={{ width: '100%', height: 350, resize: 'none', fontFamily: 'Pretendard' }}
                    />
                  </ModalInput>
                </div>
              )}
              {choose == '삭제' && (
                <div style={{position: 'relative'}}>
                  <ModalInput style={{padding: 20, textAlign: 'center', paddingBottom: 10}}>
                    <label htmlFor='name' style={{fontSize: 22, fontWeight: 600}}>카테고리 삭제</label>
                    <ModalSubmit style={{backgroundColor: '#f93e3e', border: 'none'}} onClick={clickDelete}>삭제</ModalSubmit>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='name'>카테고리</label>
                    <Select value={categoryDelete} onChange={(e) => setCategoryDelete(e)} placeholder='카테고리 선택' style={{fontFamily: 'Pretendard'}}>
                      {categoryList?.map(it => (
                        <option value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
                      ))}
                    </Select>
                  </ModalInput>
                </div>
              )}
              {choose == '' && (
                <div>
                  <ModalInput style={{padding: 20, textAlign: 'center', paddingBottom: 10}}>
                    <label htmlFor='name' style={{fontSize: 22, fontWeight: 600}}>카테고리 리스트</label>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='name'>카테고리</label>
                    <Select value={category} onChange={(e) => setCategory(e)} placeholder='카테고리 선택' style={{fontFamily: 'Pretendard'}}>
                      {categoryList?.map(it => (
                        <option value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
                      ))}
                    </Select>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='desc'>템플릿</label>
                    <div style={{border: '1px solid #d8d8d8', minHeight: 350, padding: 10, borderRadius: 8, whiteSpace: 'pre-wrap'}}>{template}</div>
                  </ModalInput>
                </div>
              )}
            </SetTemplateSelect>
          </SetTemplateWrapper>
        </ModalWrapper>
      :
        <ModalWrapper>
          <ModalHeader>
            <Icon onClick={() => setIsSetTemplate(false)}><FaChevronLeft /></Icon>
            <ModalTitle>템플릿 관리</ModalTitle>
            <div></div>
          </ModalHeader>
          <SetTemplateWrapper>
            <SetTemplateSelect>
              {choose == '등록' && (
                <div style={{position: 'relative'}}>
                  <ModalInput style={{padding: 20, textAlign: 'center', paddingBottom: 10}}>
                    <label htmlFor='name' style={{fontSize: 22, fontWeight: 600}}>카테고리 등록</label>
                    <ModalSubmit style={{position: 'absolute', right: 20, backgroundColor: '#49cc90', border: 'none'}} onClick={clickAdd}>등록</ModalSubmit>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='name'>카테고리</label>
                    <Input type='text' value={categoryAdd} onChange={(e) => setCategoryAdd(e.target.value)} placeholder='등록하실 카테고리명을 입력해주세요.' />
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='desc'>내용입력</label>
                    <TextArea
                      value={templateAdd}
                      onChange={(e) => setTemplateAdd(e.target.value)}
                      placeholder="등록하실 템플릿을 입력해주세요."
                      style={{ width: '100%', height: 350, resize: 'none', fontFamily: 'Pretendard' }}
                    />
                  </ModalInput>
                </div>
              )}
              {choose == '수정' && (
                <div style={{position: 'relative'}}>
                  <ModalInput style={{padding: 20, textAlign: 'center', paddingBottom: 10}}>
                    <label htmlFor='name' style={{fontSize: 22, fontWeight: 600}}>카테고리 수정</label>
                    <ModalSubmit style={{position: 'absolute', right: 20, backgroundColor: '#fca130', border: 'none'}} onClick={clickEdit}>수정</ModalSubmit>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='name'>카테고리</label>
                    <Select value={categoryEdit} onChange={(e) => setCategoryEdit(e)} placeholder='카테고리 선택' style={{fontFamily: 'Pretendard'}}>
                      {categoryList?.map(it => (
                        <option value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
                      ))}
                    </Select>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='name'>카테고리 수정</label>
                    <Input type='text' value={categoryEditTxt} onChange={(e) => setCategoryEditTxt(e.target.value)} />
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='desc'>내용입력</label>
                    <TextArea
                      value={templateEdit}
                      onChange={(e) => setTemplateEdit(e.target.value)}
                      placeholder="카테고리 선택 후 작성"
                      style={{ width: '100%', height: 350, resize: 'none', fontFamily: 'Pretendard' }}
                    />
                  </ModalInput>
                </div>
              )}
              {choose == '삭제' && (
                <div style={{position: 'relative'}}>
                  <ModalInput style={{padding: 20, textAlign: 'center', paddingBottom: 10}}>
                    <label htmlFor='name' style={{fontSize: 22, fontWeight: 600}}>카테고리 삭제</label>
                    <ModalSubmit style={{position: 'absolute', right: 20, backgroundColor: '#f93e3e', border: 'none'}} onClick={clickDelete}>삭제</ModalSubmit>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='name'>카테고리</label>
                    <Select value={categoryDelete} onChange={(e) => setCategoryDelete(e)} placeholder='카테고리 선택' style={{fontFamily: 'Pretendard'}}>
                      {categoryList?.map(it => (
                        <option value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
                      ))}
                    </Select>
                  </ModalInput>
                </div>
              )}
              {choose == '' && (
                <div>
                  <ModalInput style={{padding: 20, textAlign: 'center', paddingBottom: 10}}>
                    <label htmlFor='name' style={{fontSize: 22, fontWeight: 600}}>카테고리 리스트</label>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='name'>카테고리</label>
                    <Select value={category} onChange={(e) => setCategory(e)} placeholder='카테고리 선택' style={{fontFamily: 'Pretendard'}}>
                      {categoryList?.map(it => (
                        <option value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
                      ))}
                    </Select>
                  </ModalInput>
                  <ModalInput style={{padding: 20}}>
                    <label htmlFor='desc'>템플릿</label>
                    <div style={{border: '1px solid #d8d8d8', minHeight: 350, padding: 10, borderRadius: 8}}>{template}</div>
                  </ModalInput>
                </div>
              )}
            </SetTemplateSelect>
            <SetTemplateChoose>
              <button onClick={() => setChoose('')} style={{backgroundColor: '#d8d8d8', color: '#4d4b4b'}}>
                리스트 보기
              </button>
              <button onClick={() => setChoose('등록')} style={{backgroundColor: '#49cc90'}}>
                등록
              </button>
              <button onClick={() => setChoose('수정')} style={{backgroundColor: '#fca130'}}>
                수정
              </button>
              <button onClick={() => setChoose('삭제')} style={{backgroundColor: '#f93e3e'}}>
                삭제
              </button>
            </SetTemplateChoose>
          </SetTemplateWrapper>

          {/* <ModalContent>
          <ModalInput>
            <label htmlFor='name'>카테고리</label>
            <Select value={category} onChange={(e) => setCategory(e)} placeholder='카테고리 선택' style={{fontFamily: 'Pretendard'}}>
              {categoryList?.map(it => (
                <option value={it.id} style={{fontFamily: 'Pretendard'}}>{it.name}</option>
              ))}
            </Select>
          </ModalInput>
          <ModalInput>
            <label htmlFor='desc'>내용입력</label>
            <TextArea
              value={template}
              onChange={(e) => setTemplate(e.target.value)}
              placeholder="카테고리 선택 후 작성"
              style={{ width: '100%', height: 200, resize: 'none', fontFamily: 'Pretendard' }}
            />
          </ModalInput>
        </ModalContent> */}
        </ModalWrapper>
      }

    </>
  )
}

export default React.memo(SetTemplate);